import { onMounted, ref, watch } from '@vue/composition-api'
import moment from '@/libs/moment'

export const dateFrom = ref(moment().startOf('year').format('YYYY-MM-DD'))
export const dateTo = ref(moment().endOf('year').format('YYYY-MM-DD'))
export function resetDate() {
  dateFrom.value = moment().startOf('year').format('YYYY-MM-DD')
  dateTo.value = moment().endOf('year').format('YYYY-MM-DD')
}
